import axios from "axios";
import { BASE_URL } from "../../api/BaseConfig";
import { FAQ_ADD_FAIL, FAQ_ADD_REQUEST, FAQ_ADD_SUCCESS, FAQ_DELETE_FAIL, FAQ_DELETE_REQUEST, FAQ_DELETE_SUCCESS, FAQ_EDIT_FAIL, FAQ_EDIT_REQUEST, FAQ_EDIT_SUCCESS, FAQ_LIST_FAIL, FAQ_LIST_REQUEST, FAQ_LIST_SUCCESS, FAQ_UPDATE_FAIL, FAQ_UPDATE_REQUEST, FAQ_UPDATE_SUCCESS } from "../Constants/FaqConstants";


//create FAQ
export const faqAdd = (faqData) => async (dispatch) => {
    try {
        dispatch({ type: FAQ_ADD_REQUEST });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const { data } = await axios.post(
            `${BASE_URL}/Faq`,
            JSON.stringify(faqData),
            config
        );
        dispatch({ type: FAQ_ADD_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: FAQ_ADD_FAIL, payload: error });
    }
};

export const faqUpdateAction = (faq) => async (dispatch, getstate) => {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        dispatch({ type: FAQ_UPDATE_REQUEST });
        const { data } = await axios.put(
            `${BASE_URL}/Faq/${faq.id}`,
            JSON.stringify(faq),
            config
        );
        dispatch({ type: FAQ_UPDATE_SUCCESS, payload: data });
        dispatch({ type: FAQ_EDIT_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: FAQ_UPDATE_FAIL, payload: error });
    }
};

//GetAll FAQs
export const listFAQs = (pageNo) => async (dispatch, getstate) => {
    try {
        dispatch({ type: FAQ_LIST_REQUEST });
    
        const { data } = await axios.get(`${BASE_URL}/Faq/all/AZ/${pageNo}`);
        dispatch({ 
          type: FAQ_LIST_SUCCESS, 
          payload: {
            faqs: data.faqs,
            currentPage: data.currentPage,
            totalPages: data.totalPages,
            totalRecords: data.totalRecords,
            recordSize: data.recordSize,
          },
        });
      } catch (error) {
        dispatch({ 
          type: FAQ_LIST_FAIL, 
          payload: error.response?.data?.message || error.message,
        });
      }
};

//Edit faq
export const faqEditAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: FAQ_EDIT_REQUEST });
        const { data } = await axios.get(`${BASE_URL}/Faq/GetbyIdWithLangFaq/${id}`);
        dispatch({ type: FAQ_EDIT_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: FAQ_EDIT_FAIL, payload: error });
    }
};

//delete faq
export const faqDelete = (id) => async (dispatch) => {
    try {
        dispatch({ type: FAQ_DELETE_REQUEST });
        await axios.delete(`${BASE_URL}/Faq/${id}`);
        dispatch({
            type: FAQ_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: FAQ_DELETE_FAIL,
            payload: error,
        });
    }
};


